import {getContainer} from './getContainer';
import {hasClickEvent} from '../core/functions';

const MODAL_OPEN_EVENT_NAME = 'modal:open';
const MODAL_CLOSE_EVENT_NAME = 'modal:close';
const MODAL_OPEN_EVENT = new Event(MODAL_OPEN_EVENT_NAME);
const MODAL_CLOSE_EVENT = new Event(MODAL_CLOSE_EVENT_NAME);

export const InitModals = (container = document) => {

    container = getContainer(container);
    const modalsButtons = container.querySelectorAll('[data-toggle="modal"]');

    modalsButtons.forEach((button) => {
        handleModalButton(button);
    });
};

const handleModalButton = (button) => {
    let modal = document.getElementById(button.getAttribute('data-target'));

    if (modal) {
        // Handle click outside of container
        modal.addEventListener('click', (event) => {
            if (!$(event.target).closest(modal.firstElementChild).length && !modal.classList.contains('hidden')) {
                if (button.getAttribute('data-variation') !== 'addToCart') {
                    hideModal(modal);
                } else {
                    // reload pagina voor csrf_token
                    location.reload();
                }
            }
        });

        if (!hasClickEvent(button)) {
            // Hide or display modal on click
            button.addEventListener('click', () => {
                handleModalContainer(modal, button);
            });
        }
    }
};

const handleModalContainer = (modal, button) => {
    if (modal.classList.contains('hidden')) {
        if (button && button.getAttribute("data-target").includes("energy")) {
            placeImageInModal(modal, button);
        }
        showModal(modal);
    } else {
        hideModal(modal);
    }
};

const hideModal = (modal) => {
    setTimeout(() => {
        modal.classList.add('hidden');
        modal.classList.remove('grid');
    }, 300);

    modal.firstElementChild.classList.remove('animate-scale-in-center');
    modal.firstElementChild.classList.add('animate-scale-out-center');

    modal.dispatchEvent(MODAL_CLOSE_EVENT);
};


const showModal = (modal) => {
    modal.firstElementChild.classList.remove('animate-scale-out-center');
    modal.firstElementChild.classList.add('animate-scale-in-center');

    modal.classList.remove('hidden');
    modal.classList.add('grid');

    modal.dispatchEvent(MODAL_OPEN_EVENT);
};

//-- place image src in modal image for pagespeed optimization - used for energy-label
const placeImageInModal = (modal, clickedModalBtn) => {
    const modalImg = modal.querySelector("img.energy-label-img");
    if (modalImg) {
        //-- Place data-src from button energy label in image src-attribute
        modalImg.src = clickedModalBtn.getAttribute("data-target-img-src");
    }
};